import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LAST_PATH_KEY = "yg_last_path";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isFirstRender = useRef(true);

  // İlk mount'ta: eğer F5 atıldıysa ve farklı bir sayfadaysak, kaydedilen URL'ye geri dön
  useEffect(() => {
    const saved = sessionStorage.getItem(LAST_PATH_KEY);
    if (saved && saved !== pathname && saved !== "/") {
      navigate(saved, { replace: true });
    }
  }, []);

  // Sayfa değiştiğinde URL'yi kaydet
  useEffect(() => {
    sessionStorage.setItem(LAST_PATH_KEY, pathname);
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
